// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.woQOllua3PU3mt5MQZ_2{flex-direction:column;gap:16px;padding-top:2px;padding-bottom:3px;display:flex}.oyVRTzoma7w9k7J0cPxz{flex-direction:column;display:flex}.zdU123RmQ8VvWEmchyZH{flex-direction:column;gap:24px;display:flex}.aqfOUbDQT0UslqmF8a73{margin-top:3px;margin-left:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `woQOllua3PU3mt5MQZ_2`,
	"messageBlock": `oyVRTzoma7w9k7J0cPxz`,
	"categories": `zdU123RmQ8VvWEmchyZH`,
	"error": `aqfOUbDQT0UslqmF8a73`
};
export default ___CSS_LOADER_EXPORT___;
